var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('label',{staticClass:"switch"},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.isEnabled},on:{"click":_vm.toggleCheckbox}}),_c('div',{staticClass:"slider round"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }